export default __webpack_public_path__ + "static/media/tie.f353fe3e.gif";